export interface Icustomer {
    email: string
    isGuest: boolean
    isRegistered: boolean
    c_acLoyaltyTier?: string
}

export interface IBuilderPageReference {
    id: string
    value: {
        data: {
            isSfraPage: boolean
            url: string
        }
    }
}

export interface LocalStorageAction {
    action: 'set' | 'get' | 'remove'
}

export interface BuilderImage {
    src: string
    altText?: string
    [key: string]: any
}
